import { computed, ref } from 'vue';
import { useTimeoutStore } from '@services/base/timeoutStore';

interface Options {
  interval: number;
}

const useTimeout = (options: Options | undefined = undefined) => {
  const isCloseToTimeout = ref(false);
  const isTimedOut = ref(false);
  const timeoutStore = useTimeoutStore();

  setInterval(() => {
    if (!timeoutStore.lastRequest) return;
    isCloseToTimeout.value = timeoutStore.isCloseToTimeout();
    isTimedOut.value = timeoutStore.isTimedout();
  }, options?.interval ?? 5000);

  return {
    isCloseToTimeout,
    isTimedOut,
    secondsUntilTimeout: computed(() => timeoutStore.secondsUntilTimeout),
  };
};

export default useTimeout;
